import { getSessionUniqueQuotes } from './quotesData';

export const injectMixedContent = (news, ads, quotesPool) => {
    if (!news || news.length === 0) return [];

    const activeQuotesPool = Array.isArray(quotesPool) ? quotesPool : [];

    const mixedContent = [];
    let totalNewsInjected = 0;
    let normalAdIndex = 0;
    let bannerAdIndex = 0;

    // Strict separations (No broad fallback lists)
    const getLayoutType = (ad) => ad.layoutType || ad.adDetails?.layoutType || '';
    const bannerAds = ads.filter(ad => ad.adType === 'banner' || ad.layoutType === 'banner');
    const fullAds = ads.filter(ad => ad.adType !== 'banner' && ad.layoutType !== 'banner');

    for (let i = 0; i < news.length; i++) {
        mixedContent.push(news[i]);
        totalNewsInjected++;

        // 1. Standalone Vertical Ad (Only render if full vertical ads are available)
        if (totalNewsInjected % 4 === 0) {
            if (fullAds.length > 0) {
                const adToInject = fullAds[normalAdIndex % fullAds.length];
                normalAdIndex++;
                
                mixedContent.push({
                    ...adToInject,
                    isAd: true,
                    id: adToInject.id,
                    adId: `${adToInject.id}_inject_${totalNewsInjected}`
                });
            }
        }

        // 2. Quotes swipe cards (Passes totalNewsInjected for deterministic purity)
        if (totalNewsInjected % 3 === 0) {
            if (activeQuotesPool.length > 0) {
                mixedContent.push({
                    isCustomQuote: true,
                    id: `quote_${totalNewsInjected}`,
                    quotesData: getSessionUniqueQuotes(totalNewsInjected)
                });
            }
        }

        // 3. Composite Recommendation Card (Only render if horizontal banner ads are available)
        if (totalNewsInjected === 5 || (totalNewsInjected > 5 && (totalNewsInjected - 5) % 20 === 0)) {
            if (bannerAds.length > 0) {
                const adToInject = bannerAds[bannerAdIndex % bannerAds.length];
                bannerAdIndex++;

                const startRecIndex = Math.max(0, i - 3);
                const recommendedItems = news.slice(startRecIndex, i + 1).slice(0, 3);

                mixedContent.push({
                    isAdRecommended: true,
                    id: `ad_rec_${totalNewsInjected}`,
                    adData: adToInject,
                    recommendedNews: recommendedItems
                });
            }
        }
    }

    return mixedContent;
};